{
  "name": "@magnopus/oko",
  "version": "4.20.1",
  "license": "unlicenced",
  "nx": {
    "tags": [
      "scope:oko",
      "type:app"
    ]
  },
  "release": "2026.22",
  "dependencies": {
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@magnopus-opensource/connected-spaces-platform-web-api": "14.15.2",
    "@magnopus-opensource/magnopus-web-common": "1.5.3",
    "@magnopus-opensource/magnopus-web-renderer": "3.18.4",
    "@magnopus/communication-agora": "0.0.1",
    "@magnopus/content": "0.0.1",
    "@magnopus/core": "0.0.1",
    "@magnopus/core-types": "0.0.1",
    "@magnopus/data-access": "0.0.1",
    "@magnopus/env": "0.0.1",
    "@magnopus/shared-ui": "0.0.1",
    "@magnopus/shared-utils": "0.0.1",
    "@magnopus/space-state": "0.0.1",
    "@magnopus/translations": "0.0.1",
    "@magnopus/ui": "0.0.1",
    "@magnopus/ui-inspace": "0.0.1",
    "@magnopus/utils": "0.0.1",
    "@mui/material": "^7.3.8",
    "@mui/system": "^7.3.8",
    "@nx/vite": "23.1.0",
    "@sentry/react": "^10.65.0",
    "@tanstack/react-query": "^5.90.20",
    "@tanstack/react-query-devtools": "^5.91.2",
    "@tanstack/react-query-persist-client": "^5.90.22",
    "@vitejs/plugin-react": "6.0.3",
    "core-js": "^3.48.0",
    "detect-gpu": "^5.0.70",
    "idb-keyval": "^6.2.2",
    "jwt-decode": "^4.0.0",
    "mapbox-gl": "^2.15.0",
    "react": "^19.2.5",
    "react-dnd": "^16.0.1",
    "react-dnd-html5-backend": "^16.0.1",
    "react-dom": "19.2.5",
    "react-intl": "^7.1.14",
    "react-map-gl": "^7.1.9",
    "react-markdown": "^10.1.0",
    "react-router": "^7.13.0",
    "regenerator-runtime": "0.13.11",
    "rehype-raw": "^7.0.0",
    "remark-gfm": "^4.0.1",
    "vite": "8.1.5",
    "vite-plugin-pwa": "^1.2.0",
    "vite-plugin-static-copy": "^3.2.0",
    "workbox-cacheable-response": "7.4.0",
    "workbox-expiration": "7.4.0",
    "workbox-precaching": "7.4.0",
    "workbox-range-requests": "7.4.0",
    "workbox-routing": "7.4.0",
    "workbox-strategies": "7.4.0",
    "zustand": "^5.0.11"
  }
}
